/**
 * [INPUT]: 依赖 index.css 的 --zncms-dither-*-{fill,line,star} RGB channel token 与浏览器 computed style
 * [OUTPUT]: 对外提供颜色名验证、Canvas seed 解析、rgba 生成与主题切换缓存失效
 * [POS]: dither-kit 引擎的唯一颜色边界，让 vendored Canvas 算法遵守 Admin CSS token 真相源
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
const COLOR_NAMES = Object.freeze([
  'green',
  'blue',
  'purple',
  'pink',
  'orange',
  'red',
  'grey',
])

const COLOR_SET = new Set(COLOR_NAMES)
const FALLBACK_SEED = Object.freeze({
  fill: Object.freeze([92, 92, 100]),
  line: Object.freeze([140, 140, 150]),
  star: Object.freeze([165, 165, 175]),
})
const seedCache = new Map()

const parseChannels = (value, fallback) => {
  const channels = value.trim().split(/\s+/).map(Number)
  return channels.length === 3 && channels.every(Number.isFinite) ? channels : fallback
}

export const isDitherColor = (value) => typeof value === 'string' && COLOR_SET.has(value)

export const clearPaletteCache = () => seedCache.clear()

export function seedOfColor(input) {
  const color = isDitherColor(input) ? input : 'grey'
  if (seedCache.has(color)) return seedCache.get(color)
  if (typeof document === 'undefined') return FALLBACK_SEED

  const styles = getComputedStyle(document.documentElement)
  const seed = Object.freeze({
    fill: parseChannels(styles.getPropertyValue(`--zncms-dither-${color}-fill`), FALLBACK_SEED.fill),
    line: parseChannels(styles.getPropertyValue(`--zncms-dither-${color}-line`), FALLBACK_SEED.line),
    star: parseChannels(styles.getPropertyValue(`--zncms-dither-${color}-star`), FALLBACK_SEED.star),
  })
  seedCache.set(color, seed)
  return seed
}

export const PALETTE = {}
COLOR_NAMES.forEach((color) => {
  Object.defineProperty(PALETTE, color, {
    enumerable: true,
    get: () => seedOfColor(color),
  })
})
Object.freeze(PALETTE)

export const rgb = ([r, g, b], k = 1, a = 1) => (
  `rgba(${Math.round(r * k)},${Math.round(g * k)},${Math.round(b * k)},${a})`
)
